



export function logOut(navigate, user) {
   localStorage.clear() ;

   user.setUser({}) ;
   user.setCountItem(null) ;
   user.setUserData({}) ;
   user.setFilter("") ;
   user.setAddNewUser({});
   user.setUsers([]) ;
   user.setRole("") ;
   user.setLoggedUser({}) ; 
   user.setUserToken("") ;
   user.setAdmin(false) ;
   user.setModerator(false)  ; 
   user.setError(null) ;
   user.setLoading(false) ;
   user.setCompleteInfoUser(true) ;
   // window.location.reload();
   
   navigate("/")
}



